import { Deserializer, Serializer } from 'jsonapi-serializer';
import { JsonApiResponse } from 'types/store/jsonApi';
import {
  ProjectOwner,
  GetProjectOwnersListParams,
} from 'types/store/projectOwners';
import { BASE_URL } from 'utils/constants/projectOwners';

export const deserialize: (
  jsonApiResponse: JsonApiResponse<ProjectOwner>
) => Promise<ProjectOwner[]> = async (jsonApiResponse) => {
  const deserializer = new Deserializer({
    keyForAttribute: 'camelCase',
    transform: (record: JsonApiResponse<ProjectOwner>) => {
      delete record['links'];
      delete record['meta'];
      return record;
    },
  });
  return await deserializer.deserialize(jsonApiResponse);
};

export const serialize: (
  data: ProjectOwner[],
  links?: Record<string, string>,
  meta?: Record<string, string | number>
) => Promise<JsonApiResponse<ProjectOwner>> = async (data, links, meta) => {
  const serializer = new Serializer('projectOwners', {
    attributes: [
      'id',
      'firstName',
      'lastName',
      'fullName',
      'email',
      'status',
      'avatarUrl',
      'isDisabled',
    ],
    topLevelLinks: links,
    meta,
  });
  return await serializer.serialize(data);
};

export const buildJsonApiUrl: (params: GetProjectOwnersListParams) => string = (
  params
) => {
  const searchParams = new URLSearchParams();
  if (params.filters) {
    Object.entries(params.filters).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        values.forEach((value) => {
          searchParams.append(`filter[${key}][]`, value);
        });
      } else {
        if (values) {
          searchParams.append(`filter[${key}]`, values as string);
        }
      }
    });
  }

  if (params.sort) {
    searchParams.append('sort', params.sort);
  } else {
    searchParams.append('sort', 'firstName,lastName');
  }

  if (params.page) {
    searchParams.append('page[limit]', params.page.limit.toString());
    if (params.page.cursor) {
      searchParams.append('page[cursor]', params.page.cursor);
    }
  } else {
    searchParams.append('page[limit]', '20');
  }

  return `${BASE_URL}?${searchParams.toString()}`;
};
